import React from 'react';
import { Button } from 'antd';
import { history } from '@umijs/max';
import { PageContainer } from '@ant-design/pro-components';
import PageHeader from '@/components/PageHeader';
import NetworkStatus from '@/components/NetworkStatus';
import './index.less';

interface PageWrapperProps {
  // 页面内容
  children: React.ReactNode;
  // 自定义面包屑
  breadcrumb?: string;
  // 自定义标题
  title?: string;
  // 返回按钮点击事件
  onBack?: () => void;
  // 右侧操作按钮
  actions?: React.ReactNode;
  // 是否显示网络状态
  showNetworkStatus?: boolean;
  // 是否强制显示为二级页面样式
  forceSecondary?: boolean;
  // 是否强制显示为一级页面样式
  forcePrimary?: boolean;
  // 内容区域的内边距
  contentPadding?: string;
  // 自定义样式类名
  className?: string;
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  breadcrumb,
  title,
  onBack,
  actions,
  showNetworkStatus = true,
  forceSecondary = false,
  forcePrimary = false,
  // contentPadding = '0 24px',
  contentPadding = '0',
  className = '',
}) => {
  // 默认返回处理
  const handleBack = onBack || (() => {
    // 自动返回上一级
    const pathname = window.location.pathname;
    const segments = pathname.split('/').filter(Boolean);

    if (segments.length > 1) {
      // 移除最后一个段落
      segments.pop();
      const parentPath = '/' + segments.join('/');
      history.push(parentPath);
    } else {
      // 如果没有上级，返回首页
      history.push('/');
    }
  });

  return (
    <PageContainer
      header={{ title: undefined, breadcrumb: undefined }} // 完全隐藏默认头部
      className={className}
    >
      <PageHeader
        breadcrumb={breadcrumb}
        title={title}
        onBack={handleBack}
        forceSecondary={forceSecondary}
        forcePrimary={forcePrimary}
      >
        {actions}
      </PageHeader>

      <div style={{ padding: contentPadding }}>
        {showNetworkStatus && <NetworkStatus showOfflineOnly position="top" />}
        {children}
      </div>
    </PageContainer>
  );
};

export default PageWrapper;
